var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.1 3.1 0 7 0C10.9 0 14 3.1 14 7C14 10.9 10.9 14 7 14C3.1 14 0 10.9 0 7ZM1 7C1 10.3 3.7 13 7 13C10.3 13 13 10.3 13 7C13 3.7 10.3 1 7 1C3.7 1 1 3.7 1 7ZM7 7.8L9.7 10.5L10.5 9.7L7.8 7L10.5 4.3L9.7 3.5L7 6.2L4.3 3.5L3.5 4.3L6.2 7L3.5 9.7L4.3 10.5L7 7.8Z",
    fill: "#34373F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIcon);
export default __webpack_public_path__ + "static/media/noIcon.ba499baa8f14b062eda0b47b61ee15af.svg";
export { ForwardRef as ReactComponent };